import axios from "axios";
import {
  MONETIZATION_CREATOR_PROFILE_URL,
  MONETIZATION_CREATOR_TIERS_URL,
  MONETIZATION_CREATOR_STATS_URL,
  MONETIZATION_PUBLIC_PROFILE_URL,
  MONETIZATION_PUBLIC_TIERS_URL,
  MONETIZATION_SUBSCRIPTIONS_URL,
  MONETIZATION_SUBSCRIPTION_ID_URL,
  MONETIZATION_OVERVIEW_URL,
  MONETIZATION_POST_PURCHASE_URL,
} from "../constants";

const authHeaders = (token) => ({
  headers: {
    authorization: token,
  },
});

export const getCreatorProfile = async (token) => {
  const response = await axios.get(
    MONETIZATION_CREATOR_PROFILE_URL,
    authHeaders(token)
  );
  return response.data;
};

export const updateCreatorProfile = async (payload, token) => {
  const response = await axios.put(
    MONETIZATION_CREATOR_PROFILE_URL,
    payload,
    authHeaders(token)
  );
  return response.data;
};

export const getCreatorTiers = async (token, includeArchived = true) => {
  const response = await axios.get(
    `${MONETIZATION_CREATOR_TIERS_URL}?includeArchived=${includeArchived}`,
    authHeaders(token)
  );
  return response.data;
};

export const upsertCreatorTier = async (payload, token) => {
  const response = await axios.post(
    MONETIZATION_CREATOR_TIERS_URL,
    payload,
    authHeaders(token)
  );
  return response.data;
};

export const archiveCreatorTier = async (tierId, token) => {
  await axios.delete(
    `${MONETIZATION_CREATOR_TIERS_URL}/${tierId}`,
    authHeaders(token)
  );
};

export const getCreatorStats = async (token) => {
  const response = await axios.get(
    MONETIZATION_CREATOR_STATS_URL,
    authHeaders(token)
  );
  return response.data;
};

export const getPublicCreatorProfile = async (username) => {
  const response = await axios.get(MONETIZATION_PUBLIC_PROFILE_URL(username));
  return response.data;
};

export const getPublicCreatorTiers = async (username) => {
  const response = await axios.get(MONETIZATION_PUBLIC_TIERS_URL(username));
  return response.data;
};

export const subscribeToTier = async (tierId, token, autoRenew = true) => {
  const response = await axios.post(
    MONETIZATION_SUBSCRIPTIONS_URL,
    { tierId, autoRenew },
    authHeaders(token)
  );
  return response.data;
};

export const cancelSubscription = async (
  subscriptionId,
  token,
  cancelImmediately = false
) => {
  await axios.delete(MONETIZATION_SUBSCRIPTION_ID_URL(subscriptionId), {
    ...authHeaders(token),
    data: { cancelImmediately },
  });
};

export const getMonetizationOverview = async (token) => {
  const response = await axios.get(MONETIZATION_OVERVIEW_URL, authHeaders(token));
  return response.data;
};

export const purchasePost = async (postId, token) => {
  const response = await axios.post(
    MONETIZATION_POST_PURCHASE_URL(postId),
    { acceptTerms: true },
    authHeaders(token)
  );
  return response.data;
};
